var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertShow)?_c('v-alert',{attrs:{"prominent":"","type":"error"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"grow"},[_vm._v(" "+_vm._s(_vm.alertText)+" ")]),_c('v-col',{staticClass:"shrink"},[_c('v-btn',{on:{"click":function($event){return _vm.$emit('closeAlert')}}},[_vm._v("Close")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }